import { useQuery } from "@tanstack/react-query";

import { getFieldPracticeFilterOptions } from "services";

import { GET_FIELD_PRACTICE_FILTER_OPTIONS } from "consts";

export const useGetFieldPracticeFilterOptions = ({ farmId }: { farmId?: string }) =>
  useQuery({
    queryKey: [GET_FIELD_PRACTICE_FILTER_OPTIONS, farmId],
    queryFn: () => getFieldPracticeFilterOptions(),
    staleTime: 1000 * 60 * 60 * 24 * 7 * 2, // 2 weeks
    enabled: !!farmId,
  });
